export function initFormHelpers() {
  const buttons = document.querySelectorAll('button[data-action="show-password"]');

  function showPassword(event) {
    const { target } = event;
    const isVisible = target.dataset.visible === 'on';
    const wrapper = target.closest('.input-wrapper');
    const input = wrapper.querySelector('input');

    input.setAttribute('type', !isVisible ? 'text' : 'password');
    target.setAttribute('data-visible', isVisible ? 'off' : 'on');
  }

  if (buttons) {
    buttons.forEach((btn) => {
      btn.addEventListener('click', showPassword);
    });
  }
}
